// Every hand-over to Healthlink's Integrated Browser goes through this path on our own
// origin, never straight to Healthlink.
//
// CloudFront rewrites anything arriving here to the `target` URL and answers with a 302,
// so the browser reaches Healthlink as a redirect rather than as a cross-origin
// navigation from our app. That is what fixes the session/CORS failures — and it is why
// a lab order sent directly answered 403 while referrals worked (Dalen, #elab-ordering
// 2026-08-07: "Url generated on fe actually hits aws cloudfront which rewrites it and
// forces browser redirect. This fixes all session issues cors etc").
//
// The path is named for referrals because they came first; the rewrite itself is generic
// over `target`, so every Healthlink flow uses it.
export const IB_REDIRECT_PATH = "/redirects/ibreferral";

export const buildIbRedirectUrl = (targetUrl) => {
  if (!targetUrl) return "";

  return `${window.location.origin}${IB_REDIRECT_PATH}?target=${encodeURIComponent(
    targetUrl
  )}`;
};

// The Integrated Browser URL with a return address appended, ready to hand to the
// redirect above. Healthlink drops these params on the way back — it returns only its own
// ?controlId — so a caller must still stash its own id somewhere that survives the trip.
export const withIbReturnUrl = (integratedBrowserUrl, returnUrl) => {
  if (!integratedBrowserUrl) return "";
  if (!returnUrl) return integratedBrowserUrl;

  return `${integratedBrowserUrl}&redirectUrl=${encodeURIComponent(returnUrl)}`;
};
